import { Controller } from "@hotwired/stimulus"
import { FrameRenderer } from "@hotwired/turbo"

export default class FieldSearchController extends Controller {
  static targets = ["input", "field", "showAllFieldsCheckbox"]
  static values = {
    showAllFields: Boolean,
  }

  toggleFieldVisibility() {
    this.showAllFieldsValue = this.showAllFieldsCheckboxTarget.checked
  }

  showAllFieldsValueChanged() {
    this.search(null)
  }

  fieldTargetConnected(target) {
    this.#toggleFieldTargetVisibility(target)
  }

  search(e, fieldsTargets = this.fieldTargets) {
    fieldsTargets.forEach((target) => {
      this.#toggleFieldTargetVisibility(target)
    })
  }

  searchOnRender(e) {
    const isFieldsTarget = e.detail.newFrame.id.startsWith("fields_")
    const isSingleFieldTarget = e.detail.newFrame.id.startsWith("field_")

    const query = this.inputTarget.value?.toLowerCase()

    if (
      (!isFieldsTarget && !isSingleFieldTarget) ||
      (!query && this.showAllFieldsValue)
    ) {
      return
    }

    e.detail.render = (currentElement, newElement) => {
      let newFieldTargets

      if (isFieldsTarget) {
        newFieldTargets = newElement.querySelectorAll(
          "[data-field-search-target='field']"
        )
      } else if (isSingleFieldTarget) {
        newFieldTargets = [newElement]
      }

      this.search(e, newFieldTargets)

      FrameRenderer.renderElement(currentElement, newElement)
    }
  }

  get #searchValue() {
    if (this.hasInputTarget) {
      return this.inputTarget.value.toLowerCase()
    } else {
      return ""
    }
  }

  #toggleFieldTargetVisibility(target) {
    const fieldName = target.dataset.fieldName.toLowerCase()

    const hasValue =
      target.querySelector("div[data-has-value]").dataset.hasValue === "true"

    const isVisible =
      fieldName.includes(this.#searchValue) &&
      (this.showAllFieldsValue || (!this.showAllFieldsValue && hasValue))

    target.classList.toggle("hidden", !isVisible)
  }
}
